import { nextTick } from 'vue'

function setPosition(el, binding, tooltipParam) {
  const tooltip = tooltipParam
  const info = el.getBoundingClientRect()
  if (binding.value.showDirection === 'left') {
    nextTick(() => {
      tooltip.style.top = `${info.top}px`
      tooltip.style.left = `${info.left - tooltip.offsetWidth}px`
    })
  }
  if (
    binding.value.showDirection === 'top' ||
    !binding.value.showDirection ||
    typeof binding.value === 'string'
  ) {
    tooltip.style.top = `${info.top - 24}px`
    tooltip.style.left = `${info.left}px`
  }
  if (binding.value.showDirection === 'bottom') {
    tooltip.style.top = `${info.top + 24}px`
    tooltip.style.left = `${info.left}px`
  }
  if (binding.value.showDirection === 'right') {
    tooltip.style.top = `${info.top}px`
    tooltip.style.left = `${info.left + info.width + 10}px`
  }
  return tooltip
}
function createTooltipDom(el, binding) {
  // 目标元素信息
  // const info = el.getBoundingClientRect()

  let tooltip
  if (document.getElementById('custom-tooltip')) {
    tooltip = document.getElementById('custom-tooltip')
    tooltip.className = 'v-tooltip__content menuable__content__active fade-in'

    tooltip = setPosition(el, binding, tooltip)
    const content = document.getElementById('custom-tooltip__content')
    content.textContent = binding.value?.tooltip || binding.value || ''
    return tooltip
  }
  tooltip = document.createElement('div')
  tooltip.id = 'custom-tooltip'
  tooltip.className = 'v-tooltip__content menuable__content__active fade-in'
  tooltip.style['max-width'] = `${500}px`
  tooltip.style['z-index'] = 1000

  const span = document.createElement('span')
  span.textContent = binding.value?.tooltip || binding.value || ''
  span.id = 'custom-tooltip__content'
  tooltip = setPosition(el, binding, tooltip)
  tooltip.appendChild(span)
  return tooltip
}

function mouseoverHandler(el, binding) {
  if (el.offsetWidth < el.scrollWidth) {
    const div = createTooltipDom(el, binding)

    const container = document.getElementById('app')
    container.appendChild(div)
  }
}

function mouseoutHandler() {
  const div = document.getElementById('custom-tooltip')
  if (div) div.className = 'v-tooltip__content  fade-out'
}

function clickHandler() {
  const div = document.getElementById('custom-tooltip')
  const container = document.getElementById('app')
  if (div) {
    container.removeChild(div)
  }
}

function addHandle(el, binding) {
  // 元素的实际宽度 el.offsetWidth
  // 实际内容的宽度 el.scrollWidth
  el.addEventListener('mouseover', () => {
    mouseoverHandler(el, binding)
  })

  el.addEventListener('mouseout', mouseoutHandler)
  if (binding.value?.shouldDisappearWhenClick) {
    el.addEventListener('click', () => {
      clickHandler()
    })
  }
}

export default {
  bind(el, binding) {
    addHandle(el, binding)
  },
  inserted() {},
  update(el, binding) {
    addHandle(el, binding)
  },
  componentUpdated() {
    // 指令所在组件的 VNode 及其子 VNode 全部更新后调用
  },
  unbind(el) {
    // 移除相关绑定
    el.removeEventListener('mouseout', mouseoutHandler)
    el.removeEventListener('click', clickHandler)
  },
}
